import { render, staticRenderFns } from "./IngredientInputSelector.vue?vue&type=template&id=1916c118&scoped=true"
import script from "./IngredientInputSelector.vue?vue&type=script&lang=js"
export * from "./IngredientInputSelector.vue?vue&type=script&lang=js"
import style0 from "./IngredientInputSelector.vue?vue&type=style&index=0&id=1916c118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916c118",
  null
  
)

export default component.exports